/**
 * Contest API helpers
 * @module lib/contest/query
 */

const { buildContestActiveUrl, resolveContestArticleId } = require('./urls');

async function fetchActiveContest(articleId) {
  const resolvedId = resolveContestArticleId(articleId);
  if (!resolvedId) return null;
  const url = buildContestActiveUrl(resolvedId);
  if (!url) return null;

  try {
    const res = await fetch(url, { credentials: 'include' });
    const data = await res.json().catch(() => null);
    if (!res.ok || !data || data.success === false) return null;
    return data.contest || null;
  } catch (_) {
    return null;
  }
}

module.exports = {
  fetchActiveContest
};
